import { curry } from 'lib/util'
import frequencies from '@model/xEcoApm/collection/frequency'

/**
 * Returns the list of available frequencies.
 *
 * @param module    current module
 * @param component event source
 * @param event     triggered event
 * @returns the list of frequencies
 */
const listFrequencyValues = (
  module: Gaia.AppModule.Spec,
  component: Gaia.Component.Spec,
  event: Gaia.PlatformEvent,
): { key: number, value: string }[] => frequencies

export default curry(listFrequencyValues)
